module.exports = __webpack_public_path__ + "img/background_image.18687b64.png";